export const GET_CONCEPTS               = 'GET_CONCEPTS';
export const CHANGE_INPUT_VALUE_CONCEPT = 'CHANGE_INPUT_VALUE_CONCEPT';
export const SAVE_CONCEPT               = 'SAVE_CONCEPT';
export const GET_ITEM_CONCEPT           = 'GET_ITEM_CONCEPT';
export const DELETE_CONCEPT             = 'DELETE_CONCEPT';
export const CONCEPT_DEFAULT_DATA       = 'CONCEPT_DEFAULT_DATA';